import { RightSectionTranslations } from './types';

export const deTranslations: RightSectionTranslations = {
    selectStatement: "Wählen Sie eine Krankheit um mehr Informationen zu sehen"
};